import type ScreenBase from "@frui.ts/screens/dist/structure/screenBase";
import { ConductorOneChildActive, Router } from "@frui.ts/screens/dist";
import LocalizationService from "services/localizationService";
import { Modules } from "config";
import { computed } from "mobx";
import CzechStatisticalOfficeReportsListViewModel from "./czechStatisticalOfficeReportsListViewModel";

const navigationName = "czech-statistical-office";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
  children: [CzechStatisticalOfficeReportsListViewModel],
})
export default class CzechStatisticalOfficeReportsViewModel extends ConductorOneChildActive<ScreenBase> {
  constructor(
    private localizationService: LocalizationService,
    private czechStatisticalOfficeReportsListViewModel: CzechStatisticalOfficeReportsListViewModel
  ) {
    super();
    this.navigationName = navigationName;

    this.children.push(this.czechStatisticalOfficeReportsListViewModel);
  }

  protected onInitialize(): Promise<any> | void {
    this.tryActivateChild(this.children[0]);
    return super.onInitialize();
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.timeCharges, `externalReports.${code}`, size);
  }

  @computed
  get name() {
    return this.translate("name");
  }
}
